export enum ProjectAfterSaveAction {
    Next = 0,
    Close
}